import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
  Button
} from "reactstrap";
import Select from "react-select";
import "./index.css";
import api from "../../api";

function PortalSuccess() {
  return (
    <Container>
      <div className="portal-container">
        <Row>
          <Col sm="12" md={{ size: 8, offset: 2 }}>
            <h2 style={{ textAlign: "center", color: "#ea8024" }}>
              Cảm ơn bạn đã để lại thông tin
            </h2>
          </Col>
        </Row>
        <Row>
          <Col sm="12" md={{ size: 10, offset: 1 }}>
            <h2 style={{ textAlign: "center", color: "#ea8024" }}>
              Chúng tôi sẽ liên lạc với bạn trong thời gian sớm nhất có thể
            </h2>
          </Col>
        </Row>
        <br />
        <br />
        <Button
          style={{ backgroundColor: "#ea8024", borderColor: "#ea8024" }}
          color="primary"
          size="lg"
          block
          onClick={event =>
            (window.location.href = "https://www.thecoffeehouse.com/")
          }
        >
          Quay trở về trang chủ The Cofee House
        </Button>
        <br />
      </div>
    </Container>
  );
}

export default PortalSuccess;
